"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
var _APButton = _interopRequireDefault(require("../common/APButton"));
var _modalActions = require("../../redux/actions/modalActions");
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _commonComponent = require("../../propTypes/commonComponent");
require("./OrderWarningModalComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('warning-order-modal');
var OrderWarningModalComponent = function OrderWarningModalComponent(_ref) {
  var isOpen = _ref.isOpen,
    close = _ref.close,
    side = _ref.side,
    orderFormType = _ref.orderFormType,
    formName = _ref.formName,
    openSubmitLimitOrderModal = _ref.openSubmitLimitOrderModal;
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  var handleOrderConfirm = function handleOrderConfirm() {
    openSubmitLimitOrderModal(orderFormType, formName);
    close();
  };
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: t('Order Warning'),
    close: close,
    customClass: bemClasses('modal')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('modal-body')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('text')
  }, side === 'buy' ? t('The current market price for this order is above the limit order price you have set and the order will therefore execute immediately up to the limit price set. Are you sure you want to proceed?') : t('The current market price for this order is below the limit order price you have set and the order will therefore execute immediately down to the limit price set. Are you sure you want to proceed?'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ap-modal__footer ".concat(bemClasses('modal-footer'))
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "button",
    onClick: handleOrderConfirm,
    styleName: _commonComponent.styleNames.additive
  }, t('Yes')), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "button",
    onClick: close
  }, t('No'))));
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openSubmitLimitOrderModal: function openSubmitLimitOrderModal(orderFormType, formName) {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.CONFIRM_ORDER_REPORT, {
        orderFormType: orderFormType,
        formName: formName
      }));
    }
  };
};
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.ORDER_WARNING
})((0, _reactRedux.connect)(null, mapDispatchToProps)(OrderWarningModalComponent));